// extracted by mini-css-extract-plugin
export default {"ct-table":"teaminsights_ct-table__gwNFd","team-card":"teaminsights_team-card__BJZQ9","table-bodyct":"teaminsights_table-bodyct__4I2Rs"};